// Device Switch Controller
// Handles client-side device detection and partial switching via Turbo Streams

import ApplicationController from "./application_controller"
import Logger from '../lib/logger'

export default class extends ApplicationController {
  static targets = ["container"]
  static values = {
    currentDevice: { type: String, default: 'mobile' },
    desktopBreakpoint: { type: Number, default: 992 }
  }

  connect() {
    this._handleResize = this.handleResize.bind(this)
    this.detectDevice()
    window.addEventListener('resize', this._handleResize)
  }

  disconnect() {
    window.removeEventListener('resize', this._handleResize)
    clearTimeout(this.resizeTimeout)
  }

  // Detect device type based on viewport width
  detectDevice() {
    const width = window.innerWidth
    const newDevice = width >= this.desktopBreakpointValue ? 'desktop' : 'mobile'
    
    // Only update if device type changed
    if (newDevice !== this.currentDeviceValue) {
      this.currentDeviceValue = newDevice
      this.switchPartial(newDevice)
    }
  }

  // Handle window resize events with debouncing
  handleResize() {
    clearTimeout(this.resizeTimeout)
    this.resizeTimeout = setTimeout(() => {
      this.detectDevice()
    }, 250)
  }

  // Switch to the appropriate partial via Turbo Stream
  async switchPartial(deviceType) {
    const quoteBundleId = this.element.dataset.id
    
    try {
      const response = await this.safeFetch(`/quote_bundles/${quoteBundleId}/switch_partial`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: JSON.stringify({
          quote_bundle_id: quoteBundleId,
          device_type: deviceType
        })
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        Logger.error('Failed to switch partial:', response.status)
      }
    } catch (error) {
      Logger.error('Error switching partial:', error)
    }
  }

  // Public method to manually trigger device detection
  refresh() {
    this.detectDevice()
  }
}